// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DateFns = require("date-fns");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function PropertyPage__ListingDetails(props) {
  var lastUpdated = props.lastUpdated;
  var items = Core__Array.keepSome([
        Core__Option.map(props.timeOnTan, (function (timeOnTan) {
                return [
                        "Time on TAN",
                        timeOnTan,
                        false
                      ];
              })),
        Core__Option.map(props.commission, (function (commission) {
                return [
                        "Concessions seller will consider",
                        commission,
                        false
                      ];
              })),
        Core__Option.map(props.nextShowing, (function (nextShowing) {
                return [
                        "Next Showing",
                        nextShowing,
                        true
                      ];
              })),
        Core__Option.map(props.expectedOnMls, (function (expectedOnMls) {
                return [
                        "Expected on MLS",
                        expectedOnMls,
                        true
                      ];
              })),
        Core__Option.map(props.willShowBeforeMls, (function (willShowBeforeMls) {
                return [
                        "Will show before MLS",
                        willShowBeforeMls,
                        true
                      ];
              })),
        Core__Option.map(props.willAcceptOffersBeforeMls, (function (willAcceptOffersBeforeMls) {
                return [
                        "Will accept offers before MLS",
                        willAcceptOffersBeforeMls,
                        true
                      ];
              })),
        Core__Option.map(props.website, (function (website) {
                return [
                        "Website",
                        website,
                        false
                      ];
              }))
      ]);
  var mobileTable = JsxRuntime.jsx("table", {
        children: JsxRuntime.jsx("tbody", {
              children: items.map(function (param) {
                    var title = param[0];
                    return JsxRuntime.jsxs("tr", {
                                children: [
                                  JsxRuntime.jsx("td", {
                                        children: title,
                                        className: "w-1/3 p-4"
                                      }),
                                  JsxRuntime.jsx("td", {
                                        children: param[1],
                                        className: ""
                                      })
                                ],
                                className: "table-row even:bg-gray-100"
                              }, title);
                  })
            }),
        className: "w-full divide-y divide-gray-200 bg-white md:hidden"
      });
  var desktopTable = JsxRuntime.jsx("table", {
        children: JsxRuntime.jsx("tbody", {
              children: items.filter(function (param) {
                      return !param[2];
                    }).map(function (param) {
                    var title = param[0];
                    return JsxRuntime.jsxs("tr", {
                                children: [
                                  JsxRuntime.jsx("td", {
                                        children: title,
                                        className: "w-1/3 p-4"
                                      }),
                                  JsxRuntime.jsx("td", {
                                        children: param[1],
                                        className: ""
                                      })
                                ],
                                className: "table-row even:bg-gray-100"
                              }, title);
                  })
            }),
        className: "w-full divide-y divide-gray-200 bg-white hidden md:table"
      });
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h2", {
                      children: "Listing details",
                      className: "text-2xl font-medium text-gray-800"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        mobileTable,
                        desktopTable
                      ],
                      className: "rounded-lg border border-gray-200 overflow-hidden mt-4"
                    }),
                lastUpdated !== undefined ? JsxRuntime.jsx("div", {
                        children: "Last updated " + DateFns.formatDistance(Caml_option.valFromOption(lastUpdated), new Date()) + " ago",
                        className: "my-4"
                      }) : null
              ]
            });
}

var make = PropertyPage__ListingDetails;

exports.make = make;
/* date-fns Not a pure module */
